import { TreeViewPlugin } from "@xeokit/xeokit-sdk";

let treeView = null;

const treeViewSetup = (viewer) => {
    if (!viewer) {
        console.error("❌ Viewer instance is not available for TreeViewPlugin.");
        return null;
    }

    if (treeView) {
        console.warn("⚠️ TreeViewPlugin is already initialized. Skipping re-initialization.");
        return treeView; // ✅ Return the existing instance instead of creating a new one
    }

    let treeViewContainer = document.getElementById("myTreeView");
    if (!treeViewContainer) {
        console.error("❌ TreeView container is missing in the DOM.");
        return null;
    }

    treeView = new TreeViewPlugin(viewer, {
        containerElement: treeViewContainer,
        hierarchy: "types",
        autoExpandDepth: 1, // ✅ Ensure nodes are expanded
    });
    // 🔍 Wait for TreeView to load before modifying nodes
    setTimeout(() => {
        if (!treeView.root) {
            console.warn("⚠️ TreeView root node is not available.");
            return;
        }

        console.log("🔍 Root Node:", treeView.root);

        // Function to rename the first node inside each model category
        const renameFirstNode = (node, newTitle) => {
            if (!node || !node.children || node.children.length === 0) return;

            const firstChild = node.children[0]; // Get the first <li> inside the <ul>

            console.log(`🔍 Found First Child: ${firstChild.title}`);

            if (firstChild.title === "0001" || firstChild.objectId.toLowerCase().includes("ifc")) {
                firstChild.title = newTitle;
                console.log(`✅ Renamed First IFC Model Node: ${firstChild.title}`);
            }

            if (firstChild.title === "0001" || firstChild.objectId.toLowerCase().includes("city")) {
                firstChild.title = newTitle;
                console.log(`✅ Renamed First City Model Node: ${firstChild.title}`);
            }

            if (firstChild.title === "0001" || firstChild.objectId.toLowerCase().includes("pointcloud")) {
                firstChild.title = newTitle;
                console.log(`✅ Renamed First Point Cloud Node: ${firstChild.title}`);
            }
        };

        // 🔹 Traverse Tree and Apply Name Changes
        treeView.withNodeTree((node) => {
            if (!node) return;

            if (node.objectId && node.objectId.toLowerCase().includes("ifc")) {
                renameFirstNode(node, "IFC Model");
            }

            if (node.objectId && node.objectId.toLowerCase().includes("city")) {
                renameFirstNode(node, "City Model");
            }

            if (node.objectId && node.objectId.toLowerCase().includes("pointcloud")) {
                renameFirstNode(node, "Point Cloud");
            }
        });

        // 🔄 Force the UI to Refresh
        treeView.setDirty();  // This forces a re-render of the tree

        console.log("✅ TreeView updated with correct first node names.");

    }, 1000); // Small delay to ensure nodes are loaded
    
   

    console.log("✅ TreeViewPlugin successfully initialized.", treeViewContainer);

    return treeView;
};

export default treeViewSetup;